import { render, staticRenderFns } from "./PropertyTables.vue?vue&type=template&id=8740ed62&"
import script from "./PropertyTables.vue?vue&type=script&lang=js&"
export * from "./PropertyTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports